export default function YourData() {
  return (
    <div className='legal-doc-body'>

      <p>
        This page explains what information MJMarry collects about you, why we use it, and how you can request a copy of
        your data from the app. It is a summary — the full details are set out in our{' '}
        <a href='/privacy'>Privacy Policy</a>, which takes precedence if anything here differs.
      </p>

      <div className='privacy terms cookies'>

        <h1>1. Information we collect</h1>
        <h2>Information you provide</h2>
        <p>
          When you register and use MJMarry, you give us information such as your name, email address, phone number,
          date of birth, gender, photos, profile and lifestyle details, religious preferences, and the search
          preferences you set (for example, age range and distance). If you contact our support team, we also keep a
          record of that conversation.
        </p>
        <h2>Information created while you use MJMarry</h2>
        <p>
          This includes your matches, likes, connection requests, the messages you exchange with other members,
          reports and blocks you make, and your subscription and purchase history.
        </p>
        <h2>Information collected automatically</h2>
        <p>
          With your permission, we collect your device location so we can show you members nearby. We also collect
          technical information such as your IP address, device type, operating system, app version, and crash logs.
        </p>
        <h2>Verification data</h2>
        <p>
          To protect members from fake accounts, we may ask for a selfie for liveness verification and a phone number
          for SMS verification. Your email address and phone number are never shown publicly.
        </p>

        <h1>2. How we use your information</h1>
        <ul>
          <li>To create and run your account and show your profile to other members.</li>
          <li>To suggest compatible matches based on your preferences and location.</li>
          <li>To deliver messages and notifications.</li>
          <li>To verify accounts and keep the community safe from fraud, abuse, and duplicate accounts.</li>
          <li>To process subscriptions and payments.</li>
          <li>To respond to your support requests.</li>
          <li>To improve and fix the app.</li>
          <li>To meet our legal obligations.</li>
        </ul>

        <h1>3. Requesting a copy of your data</h1>
        <p>
          You can ask for a copy of the personal data linked to your MJMarry account at any time from the app:
        </p>
        <ol>
          <li>Open the MJMarry app and go to your <strong>Profile</strong>, then <strong>Settings</strong>.</li>
          <li>Under <strong>Privacy</strong>, tap <strong>Request a Copy of Your Data</strong>.</li>
          <li>Tap <strong>Request Download</strong>.</li>
        </ol>
        <p>
          We will prepare your data and send you a notification when it is ready to download. To protect your privacy,
          we only release data to the signed-in account holder.
        </p>
        <h2>What your download includes</h2>
        <ul>
          <li>Your account and profile information.</li>
          <li>Your photos.</li>
          <li>Your matches and connection history.</li>
          <li>Your activity on MJMarry.</li>
        </ul>
        <p>
          Your download will not include information that would reveal another member's personal data, such as the
          details of a report made about you.
        </p>

        <h1>4. Your other choices</h1>
        <ul>
          <li><strong>Update your information:</strong> you can edit your profile, photos, and preferences in the app at any time.</li>
          <li><strong>Location:</strong> you can turn off location access in your device settings.</li>
          <li><strong>Notifications:</strong> you can manage push notifications in the app or your device settings.</li>
          <li><strong>Disable or delete your account:</strong> available under Account Operations in the app's Settings.</li>
        </ul>

        <h1>5. How long we keep your data</h1>
        <p>
          If you disable or delete your account, your profile and photos stop being visible to other members straight
          away. We keep some account data for a limited period to prevent fraud and duplicate accounts, enforce our
          Terms, and meet legal requirements, after which personally identifiable details are anonymised. See sections
          13–15 of our <a href='/privacy'>Privacy Policy</a> for the full details.
        </p>

        <h1>6. Contact us</h1>
        <p>
          If you have questions about your data or need help with a request, email us
          at <a href='mailto:support@mjmarry.com'>support@mjmarry.com</a> or visit our <a href='/contactus'>Contact Us</a> page.
        </p>
      </div>
    </div>
  );
}
